// report 模組 W1：匯出/download 頁群 10 頁的整頁 body（批次 14，Gitea issue #22）。
// 掛在 PageBehavior.reportBody（ReportPage hooks 前早退；complexBody 同款 opt-in）。
//
// 行號基準＝ePortfolio_work/ePortfolio-tsgh（逐檔 grep -n 親驗 2026-09-24；JSP 行號為 .jsp 檔、
// JS 行號為 js-my/*.js 檔，分開標注）。
//
// 各頁形狀（查詢表單＋匯出鈕；**legacy 無結果表**——匯出直接 fileDownload）：
//   1. classFormExport（課程表單匯出，common/classFormExport.jsp）：表單 :156-296（學年度 hide 群
//      :156-165 value 0=全部（select :160）／醫院 :171-181（:173）／訓練類別 :181-187（:183）／
//      科部 :188-194（:190）／kind :196-203 全部/課程/會議（:198）／課程類別 :204-212（:209）／
//      表單名稱 formDepartmentId :214-222（:218）＋formTemplateId :222-230（:224）／課程期間
//      classStartDate/classEndDate :230-256（readonly datepicker :234/:240＋橡皮擦 :245）／評分顯示方式
//      radio isShowScore false 文字描述(checked)/true 分數 :248-253（:251/:252）／額外資訊 checkbox
//      showEvaluator 評核者/showRated 受評者（**無 name**，id 讀值 :258/:259）／表單進行狀態 radio
//      formStatus '' 全部(checked)/false 進行中/true 已完成 :261-269（:265-267）／匯出鈕 :272-276（:274））＋
//      說明 ol :281-284。
//      doExport（:82-134）：未選取表單名稱!（:84）→ valid()（:87）→ 日期選取不正確!（:89-94，
//      isAfterOrSame common.js:650-655）→ fileDownload downloadClassFormExcel（:118）→
//      NoData 查不到資料!（:128）／下載檔案失敗！（:130）。
//   2. clazzAttendanceExport（課堂表現，common/clazzAttendanceExport.jsp）：表單 :113-196（annualId
//      hide 群 :117-126 value 0（select :121）／醫院 :127-137 required（:129）／訓練類別 :137-144（:139）／
//      科部 :144-150（:146）／kind :150-160（:153）／課程類別 :160-170（:165）／課程期間
//      beginDate/endDate :170-190（:174/:180）＋橡皮擦 :185-189／匯出鈕 id=btnQuery :190-194（:192））。doExport（:70-80）：valid()（:71）→ fileDownload downloadExcel（:76）→
//      查不到資料!（:86）／下載檔案失敗！（:88）。
//   3. clazzDetailExport（開課明細表，common/clazzDetailExport.jsp）：同 2 的雙胞胎（diff 僅標題
//      clazz.detail.export／downloadClazzDetailExcel URL :77／權限名）；doExport :71-81（valid :72／
//      fileDownload :77／查不到資料! :87／下載檔案失敗！:89）。
//   4. planFormExport（訓練計畫表單匯出，common/planFormExport.jsp）：表單 :188-325（學年度 :195-207
//      isDefault 預設（select :201）／醫院 :208-216 required／訓練類別 :216-222 required／科部 hidden 群
//      :222-230／訓練計畫 :230-236 required／組別 phaseTargetId :236-243／訓練階段科部
//      phaseDepartmentId :243-249 required（**label 無星** :243）／訓練階段類型 phaseType :251-262
//      全部/計劃/組別/階段/子階段/選修1/選修2/外訓醫院（select :251）／表單名稱 formDepartmentId
//      :265-271（:267）＋formTemplateId :271-279 required（:273）／訓練期間 trainingStartDate/EndDate
//      :275-300 dateMonth（:280）＋橡皮擦 :295-299／評分顯示方式 :295-300（:297/:298）／額外資訊
//      :300-310（:304）／表單進行狀態 :309-315（:311-313）／匯出鈕 :318-322（:320））＋說明 ol :327-332。
//      doExport（:103-176）：未選取訓練類別!（:105）→ 未選取訓練計畫!（:110，空或 -1）→
//      未選取表單名稱!（:115）→ 日期選取不正確!（:119-124）→ 月處理（:126-133，長度 7→起日 -01/
//      訖日 endOf month）→ fileDownload downloadPlanFormExcel（:159）→ 查不到資料!（:169）／
//      下載檔案失敗！（:171）。
//   5. allStudentScores（西醫PGY_學員各訓練階段總成績，pgywm/allStudentScores.jsp＋js-my/report/
//      allStudentScores.js）：表單 :27-84（學年度 :29-39 isDefault（select :31）／醫院 :39-49（:41）／
//      訓練類別 jobTypeId 靜態 西醫PGY value=2 selected :51-53（:52）／訓練計畫名稱 planTargetId
//      :54-60（:59）／組別 phaseTargetGroupId :61-67（:65）／學員 searchStudentCode :68-76
//      placeholder『(請輸入學員姓名或學員編號)』（:72）＋studentId select（:76）配對
//      setAccountListByParamsForAllScores js:101-127（關鍵字過濾打後端；雛形以平列池不過濾
//      【雛形值待實機校準】）／匯出鈕 :80-84（:82））。
//      doExport（js:55-89）：請選擇訓練計畫!（js:67，legacy 判準 `planTargetId == null`——雛形以
//      空值/-1 同攔＝intent 鏡像【雛形值待實機校準】；legacy 帶 -1 送出由 server NoData 收）→
//      fileDownload tsghrpt/pgywm/allStudentScores/export（js:73）→ 查不到資料!（js:83）／
//      下載檔案失敗！（js:85）。
//   6. gpaFormReport（等第制表單明細，tsgh/gpaFormReport.jsp＋js-my/report/gpaFormReport.js）：
//      表單 :28-120（學年度 :29-39（select :31）／醫院 :39-49（:41）／訓練類別 jobTypeId 靜態
//      西醫UGY value=1 selected :51-53（:52）／訓練計畫名稱 planTargetId :54-60（:59）／訓練階段科部
//      phaseTargetDeptId :61-67（:65）／訓練階段類型 phaseType :69-80（select :71）／表單名稱
//      formTemplateId :81-95（select :85；**-1 請選擇 disabled selected** :86）／訓練期間
//      trainingStartDate/EndDate **day picker** :93-118 required（input :97；js init 預設今天
//      js:39-41，雛形固定 2026-01-05【雛形值待實機校準】）／匯出鈕 :112-116（:114））＋說明 li :119-123。
//      doExport（js:45-105）：請選擇訓練計畫!（js:61，==null；雛形同 5 的 intent 攔）→
//      請選擇表單!（js:66，==null；JSP 預設 -1 請選擇——雛形攔 -1/空值【雛形值待實機校準】）→
//      請選開始時間!（js:79）→ 請選擇結束時間!（js:84）→ fileDownload **tsghrpt/gapFormReport/export**
//      （js:90，**gap typo＝legacy-known-issue 照實註記**）→ 查不到資料!（js:100）／下載檔案失敗！（js:102）。
//   7. courseFormFinishrate（課程表單完成率監測，ugywm/courseFormFinishrate.jsp＋js-my/
//      courseFormFinishrate.js）：表單 :30-112（醫院 靜態 三軍總醫院 value=7 :34-40／訓練類別 靜態
//      請選擇 placeholder＋西醫UGY 1/中醫UGY 222/牙醫PGY 223 :41-45／部門 departmentId required :54-66／
//      kind :60-66 全部(checked)＋kindList（契約捕捉 僅會議；select :62）／課程類別 courseTypeId :68-77／
//      期間 StartDate/EndDate **dateMonth** :79-100 required（label :81；name=StartDate/EndDate）／
//      匯出鈕 onclick=doQuery :100-105（:102））。initBeginDate js:67-73 預填當月（+1）。
//      doQuery（js:115-166）：valid()（js:116）→ 月處理（js:119-129，起月首日/訖月末日）→
//      日期選取不正確!（js:130-133）→ fileDownload tsghrpt/ugywm/downloadCourseFormFinishrateExcel
//      （js:147-148）→ 查不到資料!（js:158）／下載檔案失敗！（js:160）。
//   8. studentDeptSatisfy（西醫UGY_學員對科部整體滿意度問卷統計，ugywm/studentDeptSatisfy.jsp）：
//      表單 :113-180（hidden departmentId value=0 :117／學年度 :119-131（label 無星；select :121）
//      0=全部＋annualList／醫院 :131-137 required（三軍總醫院 靜態 value=7）／訓練類別 :137-143
//      （西醫UGY 靜態 value=1）／訓練計畫 planTargetId :143-150 required（label 無星、select required）／
//      訓練期間(起迄) trainingStartDate/EndDate :151-172 required day picker（input :155）／匯出鈕
//      onclick=doQuery :172-177）。
//      doQuery（:45-99）：未選擇訓練計畫（:47，== '-1'）→ valid()（:50）→ 日期選取不正確!（:53-57）→
//      月處理（:66-73）→ fileDownload downloadStudentDeptSatisfyExcel（:80）→ 查不到資料!（:90）／
//      下載檔案失敗！（:92）。
//   9/10. coreSkillFormReport／coreSkillSutdentReport（核心技能統計(依技能)/(依學員)，
//      tsgh/coreSkill*.jsp 雙胞胎）：雙欄表單（form :162；左欄 :163-201：學年度／醫院 required／
//      訓練類別 required／科部 hidden 群／訓練計畫 required（:196 星）；右欄 :209-248：學年度2／
//      醫院2／訓練類別2／科部2 hidden／訓練計畫2（:246 星））＋匯出鈕 download() :203-207（:205）。
//      download（:115-141）：valid()（:116）→ 未選擇訓練計畫（:119-121，== '-1'；雛形同攔空值）→
//      fileDownload downloadCoreSkillFormReport（:127）／downloadCoreSkillSutdentReport →
//      查不到資料!（:137）／下載檔案失敗！（:139）。
//
// 雛形資料策略：
//   - 匯出＝`dataSource.list(pageId, { filters, export: true })`（D-1 第 2a 點）→ info
//     (t('export.notice')，不落地檔案 B1-3 模式)；失敗 alert（查不到資料!/下載檔案失敗！鏡像，
//     mock 無 NoData 區分→legacy failure 訊息優先退『下載檔案失敗！』【雛形值待實機校準】）。
//   - payload（filters）＝named 欄位＋id 讀值欄位**全帶**（legacy para 為子集——organizationId/
//     courseTypeId/formDepartmentId 等 legacy 用 id 讀但未入 para，雛形全帶＝C5-h 接線，差異記進度檔）。
//   - 查詢日期：day picker→原生 type=date、dateMonth→原生 type=month（值 YYYY-MM，月處理照鏡像）
//     【雛形值待實機校準】；橡皮擦鈕照畫（清起訖）。
//   - select 池：static 照 JSP/契約；dynamic 以既有池平列【雛形值待實機校準】。
// 【證據等級】§7 第 3 級（原始碼）。

import { useState, type ReactElement } from 'react';
import { Button } from '@/components/base/Button';
import { Checkbox } from '@/components/base/Checkbox';
import { Radio } from '@/components/base/Radio';
import { Select } from '@/components/base/Select';
import { TextInput } from '@/components/base/TextInput';
import { useDialogs } from '@/components/layouts';
import {
  isAfterOrSame,
  monthRangePayload,
  ReportPanel,
  ReportRow,
  runReportExport,
} from './ReportKit';
import {
  ACCOUNT_DEPARTMENT_OPTIONS,
  ACCOUNT_JOB_TYPE_OPTIONS,
  ACCOUNT_ORGANIZATION_OPTIONS,
  COURSE_CLAZZ_ANNUAL_OPTIONS,
  COURSE_CLAZZ_COURSE_TYPE_OPTIONS,
  COURSE_CLAZZ_FORM_TEMPLATE_OPTIONS,
  COURSE_CLAZZ_PLAN_TARGET_OPTIONS,
  COURSE_CLAZZ_PHASE_OPTIONS,
  COURSE_CLAZZ_STUDENT_POOL,
  REPORT_JOB_TYPE_FINISHRATE_OPTIONS,
  REPORT_JOB_TYPE_PGY,
  REPORT_JOB_TYPE_UGY,
  REPORT_KIND_FINISHRATE_OPTIONS,
  REPORT_KIND_OPTIONS,
  REPORT_PHASE_TYPE_OPTIONS,
  REPORT_PHASE_TYPE_PLAN_OPTIONS,
} from '@/mocks/resource-rules';
import { useDataSource } from '@/mocks';
import { selectOptionsOverride } from '@/mocks/legacy-fields';

/** jquery.validate 全域訊息（decorator.jsp:262）。 */
const REQUIRED_TEXT = '必填欄位';

interface BodyContext {
  v: Readonly<Record<string, string>>;
  set: (key: string, next: string) => void;
  errors: Readonly<Record<string, string>>;
}

/** 匯出頁共用外殼（LegacyContractModals＋panel＋表單＋動作鈕＋說明）。 */
function ExportBodyShell(props: {
  pageId: string;
  title: string;
  actionLabel: string;
  actionUiId: string;
  values: Record<string, string>;
  onSet: (key: string, next: string) => void;
  errors: Readonly<Record<string, string>>;
  fields: (ctx: BodyContext) => ReactElement;
  /** 驗證鏉（legacy 順序）。回傳：字串＝alert 該文字並中止；''＝inline 錯誤已掛欄位
   *  （jquery validate 行為，legacy `valid() false → return false` 不發 fileDownload，
   *  F1 複驗）；null＝全部通過。 */
  chain: (ctx: BodyContext) => Promise<string | null>;
  payload: (v: Readonly<Record<string, string>>) => Record<string, string>;
  note?: readonly string[];
  onDone?: () => void;
}): ReactElement {
  const dataSource = useDataSource();
  const dialogs = useDialogs();
  const ctx: BodyContext = {
    v: props.values,
    set: props.onSet,
    errors: props.errors,
  };
  const run = () => {
    void (async () => {
      const blocking = await props.chain(ctx);
      if (blocking !== null) {
        if (blocking !== '') {
          await dialogs.alert(blocking);
        }
        return; // inline（''）或 alert（文字）都不匯出（F1：legacy valid() false → return false）
      }
      await runReportExport({
        pageId: props.pageId,
        filters: props.payload(props.values),
        dataSource,
        dialogs,
      });
      props.onDone?.();
    })();
  };
  return (
    <ReportPanel
      pageId={props.pageId}
      title={props.title}
      note={props.note}
      actions={
        <Button
          uiId={props.actionUiId}
          variant="primary"
          size="sm"
          type="button"
          // C5-j：匯出真的呼叫 dataSource.list(export:true)（D-1 第 2a 點）。
          dataEffect={`list:${props.pageId}#export`}
          onClick={run}
        >
          {props.actionLabel}
        </Button>
      }
    >
      {props.fields(ctx)}
    </ReportPanel>
  );
}

// ---------------------------------------------------------------------------
// 逐頁 body（10 頁）。values 鍵＝legacy name（C5-h）；無 name 的欄位鍵＝legacy id。
// ---------------------------------------------------------------------------

/** 表單名稱雙下拉（formDepartmentId＋formTemplateId 共用一個 label；classFormExport.jsp:224-239）。 */
function FormNameFields(props: { pageId: string; ctx: BodyContext; templateRequired: boolean }) {
  const { pageId, ctx } = props;
  return (
    <>
      <ReportRow pageId={pageId} name="formDepartmentId" label="表單名稱：" star>
        <Select
          uiId={`${pageId}-field-form-department-id`}
          name="formDepartmentId"
          value={ctx.v['formDepartmentId'] ?? ''}
          onChange={(next) => {
            ctx.set('formDepartmentId', next);
          }}
          options={selectOptionsOverride(pageId, 'formDepartmentId') ?? ACCOUNT_DEPARTMENT_OPTIONS}
          {...(selectOptionsOverride(pageId, 'formDepartmentId') ? {} : { placeholder: '請選擇' })}
        />
      </ReportRow>
      <ReportRow pageId={pageId} name="formTemplateId" label="" star={props.templateRequired}>
        <Select
          uiId={`${pageId}-field-form-template-id`}
          name="formTemplateId"
          value={ctx.v['formTemplateId'] ?? ''}
          onChange={(next) => {
            ctx.set('formTemplateId', next);
          }}
          options={selectOptionsOverride(pageId, 'formTemplateId') ?? COURSE_CLAZZ_FORM_TEMPLATE_OPTIONS}
          {...(selectOptionsOverride(pageId, 'formTemplateId') ? {} : { placeholder: '請選擇' })}
          invalid={ctx.errors['formTemplateId'] !== undefined}
        />
        {ctx.errors['formTemplateId'] === undefined ? null : (
          <div data-ui-id={`${pageId}-error-form-template-id`} className="text-xs text-danger">
            {ctx.errors['formTemplateId']}
          </div>
        )}
      </ReportRow>
    </>
  );
}

/** 評分顯示方式＋額外資訊＋表單進行狀態（classFormExport.jsp:267-284／planFormExport.jsp:305-326）。 */
function ScoreStatusFields(props: { pageId: string; ctx: BodyContext }) {
  const { pageId, ctx } = props;
  return (
    <>
      <ReportRow pageId={pageId} name="isShowScore" label="評分顯示方式：">
        <div className="flex items-center gap-3">
          <Radio
            uiId={`${pageId}-field-is-show-score-false`}
            name="isShowScore"
            value="false"
            checked={(ctx.v['isShowScore'] ?? 'false') === 'false'}
            onChange={(checked) => {
              if (checked) {
                ctx.set('isShowScore', 'false');
              }
            }}
            label="文字描述"
          />
          <Radio
            uiId={`${pageId}-field-is-show-score-true`}
            name="isShowScore"
            value="true"
            checked={ctx.v['isShowScore'] === 'true'}
            onChange={(checked) => {
              if (checked) {
                ctx.set('isShowScore', 'true');
              }
            }}
            label="分數"
          />
        </div>
      </ReportRow>
      {/* 額外資訊（showEvaluator/showRated **無 name**，id 讀值——照實不給 name）。 */}
      <div className="flex items-start gap-2">
        <span className="w-24 shrink-0 text-sm">額外資訊：</span>
        <div className="flex items-center gap-3">
          <Checkbox
            uiId={`${pageId}-field-show-evaluator`}
            checked={ctx.v['showEvaluator'] === '1'}
            label="評核者"
            onChange={(checked) => {
              ctx.set('showEvaluator', checked ? '1' : '');
            }}
          />
          <Checkbox
            uiId={`${pageId}-field-show-rated`}
            checked={ctx.v['showRated'] === '1'}
            label="受評者"
            onChange={(checked) => {
              ctx.set('showRated', checked ? '1' : '');
            }}
          />
        </div>
      </div>
      <ReportRow pageId={pageId} name="formStatus" label="表單進行狀態：">
        <div className="flex items-center gap-3">
          {(
            [
              { value: '', label: '全部' },
              { value: 'false', label: '進行中' },
              { value: 'true', label: '已完成' },
            ] as const
          ).map((option) => (
            <Radio
              key={option.value}
              uiId={`${pageId}-field-form-status-${option.value === '' ? 'all' : option.value}`}
              name="formStatus"
              value={option.value}
              checked={(ctx.v['formStatus'] ?? '') === option.value}
              onChange={(checked) => {
                if (checked) {
                  ctx.set('formStatus', option.value);
                }
              }}
              label={option.label}
            />
          ))}
        </div>
      </ReportRow>
    </>
  );
}

/** 課程期間/訓練期間起訖（day type=date）＋橡皮擦（classFormExport.jsp:240-266 同款）。 */
function DateRangeFields(props: {
  pageId: string;
  ctx: BodyContext;
  label: string;
  startName: string;
  endName: string;
  star?: boolean;
  required?: boolean;
  kind?: 'date' | 'month';
  defaultValue?: string;
}) {
  const { pageId, ctx } = props;
  const type = props.kind ?? 'date';
  const control = (name: string, uiSuffix: string) =>
    type === 'month' ? (
      <input
        data-ui-id={`${pageId}-field-${uiSuffix}`}
        name={name}
        type="month"
        required={props.required}
        className="rounded border border-border px-2 py-1 text-sm"
        value={ctx.v[name] ?? ''}
        onChange={(event) => {
          ctx.set(name, event.target.value);
        }}
      />
    ) : (
      <input
        data-ui-id={`${pageId}-field-${uiSuffix}`}
        name={name}
        type="date"
        required={props.required}
        className="rounded border border-border px-2 py-1 text-sm"
        value={ctx.v[name] ?? ''}
        onChange={(event) => {
          ctx.set(name, event.target.value);
        }}
      />
    );
  return (
    <>
      <ReportRow pageId={pageId} name={props.startName} label={props.label} star={props.star} error={ctx.errors[props.startName]}>
        {control(props.startName, props.startName)}
      </ReportRow>
      <ReportRow pageId={pageId} name={props.endName} label="~" error={ctx.errors[props.endName]}>
        {control(props.endName, props.endName)}
        <Button
          uiId={`${pageId}-field-eraser-${props.startName}`}
          variant="default"
          size="sm"
          type="button"
          onClick={() => {
            ctx.set(props.startName, '');
            ctx.set(props.endName, '');
          }}
        >
          清除
        </Button>
      </ReportRow>
    </>
  );
}

/** jquery validate required 的 inline 鏡像（decorator.jsp:262）：回欄位錯誤表。 */
function requiredErrorsOf(
  ctx: BodyContext,
  names: readonly string[],
): Record<string, string> | null {
  const errors: Record<string, string> = {};
  for (const name of names) {
    if ((ctx.v[name] ?? '').trim() === '') {
      errors[name] = REQUIRED_TEXT;
    }
  }
  return Object.keys(errors).length === 0 ? null : errors;
}

// ---------------------------------------------------------------------------
// 1. 課程表單匯出（report-common-class-form-export）
// ---------------------------------------------------------------------------

const CLASS_FORM_EXPORT_INITIAL: Record<string, string> = {
  annualId: '0', // hide 群：value 0=全部（classFormExport.jsp:170-179）
  organizationId: '',
  jobTypeId: '',
  departmentId: '',
  kind: '',
  courseTypeId: '',
  formDepartmentId: '',
  formTemplateId: '',
  classStartDate: '',
  classEndDate: '',
  isShowScore: 'false', // 文字描述 checked（:267-272）
  showEvaluator: '',
  showRated: '',
  formStatus: '',
};

export function ClassFormExportBody({ pageId }: { pageId: string }): ReactElement {
  const [values, setValues] = useState<Record<string, string>>(CLASS_FORM_EXPORT_INITIAL);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  return (
    <ExportBodyShell
      pageId={pageId}
      title="課程表單匯出"
      actionLabel="匯出"
      actionUiId={`${pageId}-export-btn`}
      values={values}
      onSet={set}
      errors={errors}
      note={[
        '評分顯示方式：欄位為級距型或選擇型時，匯出文字描述或是分數值。',
        '評核者及受評者需要在表單的流程上設定才會有值。',
      ]}
      fields={(ctx) => (
        <>
          {/* 學年度（hide 群 :170-179）：select 照畫、容器藏（C5-h 仍可驅動）。 */}
          <div className="hidden">
            <ReportRow pageId={pageId} name="annualId" label="學年度：" star>
              <Select
                uiId={`${pageId}-field-annual-id`}
                name="annualId"
                value={ctx.v['annualId'] ?? '0'}
                onChange={(next) => {
                  ctx.set('annualId', next);
                }}
                options={selectOptionsOverride(pageId, 'annualId') ?? [{ value: '0', label: '全部' }]}
              />
            </ReportRow>
          </div>
          <ReportRow pageId={pageId} name="organizationId" label="醫院：" star error={ctx.errors['organizationId']}>
            <Select
              uiId={`${pageId}-field-organization-id`}
              name="organizationId"
              value={ctx.v['organizationId'] ?? ''}
              onChange={(next) => {
                ctx.set('organizationId', next);
              }}
              options={selectOptionsOverride(pageId, 'organizationId') ?? ACCOUNT_ORGANIZATION_OPTIONS}
              {...(selectOptionsOverride(pageId, 'organizationId') ? {} : { placeholder: '請選擇' })}
              invalid={ctx.errors['organizationId'] !== undefined}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="jobTypeId" label="訓練類別：" star error={ctx.errors['jobTypeId']}>
            <Select
              uiId={`${pageId}-field-job-type-id`}
              name="jobTypeId"
              value={ctx.v['jobTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('jobTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'jobTypeId') ?? ACCOUNT_JOB_TYPE_OPTIONS}
              {...(selectOptionsOverride(pageId, 'jobTypeId') ? {} : { placeholder: '請選擇' })}
              invalid={ctx.errors['jobTypeId'] !== undefined}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="departmentId" label="科部：" star error={ctx.errors['departmentId']}>
            <Select
              uiId={`${pageId}-field-department-id`}
              name="departmentId"
              value={ctx.v['departmentId'] ?? ''}
              onChange={(next) => {
                ctx.set('departmentId', next);
              }}
              options={selectOptionsOverride(pageId, 'departmentId') ?? ACCOUNT_DEPARTMENT_OPTIONS}
              {...(selectOptionsOverride(pageId, 'departmentId') ? {} : { placeholder: '請選擇' })}
              invalid={ctx.errors['departmentId'] !== undefined}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="kind" label="類型：">
            <Select
              uiId={`${pageId}-field-kind`}
              name="kind"
              value={ctx.v['kind'] ?? ''}
              onChange={(next) => {
                ctx.set('kind', next);
              }}
              options={selectOptionsOverride(pageId, 'kind') ?? REPORT_KIND_OPTIONS}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="courseTypeId" label="課程類別：">
            <Select
              uiId={`${pageId}-field-course-type-id`}
              name="courseTypeId"
              value={ctx.v['courseTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('courseTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'courseTypeId') ?? COURSE_CLAZZ_COURSE_TYPE_OPTIONS}
              {...(selectOptionsOverride(pageId, 'courseTypeId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <FormNameFields pageId={pageId} ctx={ctx} templateRequired />
          <DateRangeFields
            pageId={pageId}
            ctx={ctx}
            label="課程期間："
            startName="classStartDate"
            endName="classEndDate"
            star
            required
          />
          <ScoreStatusFields pageId={pageId} ctx={ctx} />
        </>
      )}
      chain={async (ctx) => {
        // :84 未選取表單名稱!
        if ((ctx.v['formTemplateId'] ?? '') === '') {
          return '未選取表單名稱!';
        }
        // :87 valid()
        const requiredErrors = requiredErrorsOf(ctx, [
          'annualId',
          'organizationId',
          'jobTypeId',
          'departmentId',
          'formTemplateId',
          'classStartDate',
          'classEndDate',
        ]);
        if (requiredErrors !== null) {
          setErrors(requiredErrors);
          return ''; // inline 錯誤已掛欄位＋不匯出（legacy valid() false → return false，:87）
        }
        setErrors({});
        // :89-94 日期選取不正確!
        if (!isAfterOrSame(ctx.v['classStartDate'] ?? '', ctx.v['classEndDate'] ?? '')) {
          return '日期選取不正確!';
        }
        return null;
      }}
      payload={(v) => ({
        // legacy para（:95-116）為子集（無 organizationId/courseTypeId/formDepartmentId）；雛形全帶＝C5-h。
        annualId: v['annualId'] ?? '',
        organizationId: v['organizationId'] ?? '',
        jobTypeId: v['jobTypeId'] ?? '',
        departmentId: v['departmentId'] ?? '',
        kind: v['kind'] ?? '',
        courseTypeId: v['courseTypeId'] ?? '',
        formDepartmentId: v['formDepartmentId'] ?? '',
        classStartDate: v['classStartDate'] ?? '',
        classEndDate: v['classEndDate'] ?? '',
        isShowScore: v['isShowScore'] ?? 'false',
        isShowEvaluator: v['showEvaluator'] === '1' ? 'true' : 'false',
        isShowRated: v['showRated'] === '1' ? 'true' : 'false',
        formStatus: v['formStatus'] ?? '',
        enableStatus: 'true',
        formTemplateId: v['formTemplateId'] ?? '', // named 原值（C5-h）；legacy para 鍵=formTemplateIdList
        formTemplateIdList: v['formTemplateId'] ?? '',
      })}
    />
  );
}

// ---------------------------------------------------------------------------
// 2/3. 課堂出席表現／開課明細表（雙胞胎：clazzAttendanceExport／clazzDetailExport）
// ---------------------------------------------------------------------------

const ATTENDANCE_EXPORT_INITIAL: Record<string, string> = {
  annualId: '0',
  organizationId: '',
  jobTypeId: '',
  departmentId: '',
  kind: '',
  courseTypeId: '',
  beginDate: '',
  endDate: '',
};

/** 雙胞胎共用 body（差異只有 pageId＋title；clazzAttendanceExport.jsp/clazzDetailExport.jsp diff 僅 13 行）。 */
function AttendanceLikeBodyInner({ pageId, title }: { pageId: string; title: string }): ReactElement {
  const [values, setValues] = useState<Record<string, string>>(ATTENDANCE_EXPORT_INITIAL);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  return (
    <ExportBodyShell
      pageId={pageId}
      title={title}
      actionLabel="匯出"
      actionUiId={`${pageId}-export-btn`}
      values={values}
      onSet={set}
      errors={errors}
      fields={(ctx) => (
        <>
          <div className="hidden">
            <ReportRow pageId={pageId} name="annualId" label="學年度：" star>
              <Select
                uiId={`${pageId}-field-annual-id`}
                name="annualId"
                value={ctx.v['annualId'] ?? '0'}
                onChange={(next) => {
                  ctx.set('annualId', next);
                }}
                options={selectOptionsOverride(pageId, 'annualId') ?? [{ value: '0', label: '全部' }]}
              />
            </ReportRow>
          </div>
          <ReportRow pageId={pageId} name="organizationId" label="醫院：" star error={ctx.errors['organizationId']}>
            <Select
              uiId={`${pageId}-field-organization-id`}
              name="organizationId"
              value={ctx.v['organizationId'] ?? ''}
              onChange={(next) => {
                ctx.set('organizationId', next);
              }}
              options={selectOptionsOverride(pageId, 'organizationId') ?? ACCOUNT_ORGANIZATION_OPTIONS}
              {...(selectOptionsOverride(pageId, 'organizationId') ? {} : { placeholder: '請選擇' })}
              invalid={ctx.errors['organizationId'] !== undefined}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="jobTypeId" label="訓練類別：">
            <Select
              uiId={`${pageId}-field-job-type-id`}
              name="jobTypeId"
              value={ctx.v['jobTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('jobTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'jobTypeId') ?? ACCOUNT_JOB_TYPE_OPTIONS}
              {...(selectOptionsOverride(pageId, 'jobTypeId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="departmentId" label="科部：">
            <Select
              uiId={`${pageId}-field-department-id`}
              name="departmentId"
              value={ctx.v['departmentId'] ?? ''}
              onChange={(next) => {
                ctx.set('departmentId', next);
              }}
              options={selectOptionsOverride(pageId, 'departmentId') ?? ACCOUNT_DEPARTMENT_OPTIONS}
              {...(selectOptionsOverride(pageId, 'departmentId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="kind" label="類型：">
            <Select
              uiId={`${pageId}-field-kind`}
              name="kind"
              value={ctx.v['kind'] ?? ''}
              onChange={(next) => {
                ctx.set('kind', next);
              }}
              options={selectOptionsOverride(pageId, 'kind') ?? REPORT_KIND_OPTIONS}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="courseTypeId" label="課程類別：">
            <Select
              uiId={`${pageId}-field-course-type-id`}
              name="courseTypeId"
              value={ctx.v['courseTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('courseTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'courseTypeId') ?? COURSE_CLAZZ_COURSE_TYPE_OPTIONS}
              {...(selectOptionsOverride(pageId, 'courseTypeId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <DateRangeFields
            pageId={pageId}
            ctx={ctx}
            label="課程期間："
            startName="beginDate"
            endName="endDate"
            star
            required
          />
        </>
      )}
      chain={async (ctx) => {
        // :71 valid()（唯 required；無日期鏈——attendance/detail 的 doExport 沒有 isAfterOrSame 檢核）
        const requiredErrors = requiredErrorsOf(ctx, [
          'annualId',
          'organizationId',
          'beginDate',
          'endDate',
        ]);
        if (requiredErrors !== null) {
          setErrors(requiredErrors);
          return ''; // legacy valid() false → return false 不匯出（:71）
        }
        setErrors({});
        return null;
      }}
      payload={(v) => ({
        annualId: v['annualId'] ?? '',
        organizationId: v['organizationId'] ?? '',
        jobTypeId: v['jobTypeId'] ?? '',
        departmentId: v['departmentId'] ?? '',
        kind: v['kind'] ?? '',
        courseTypeId: v['courseTypeId'] ?? '',
        beginDate: v['beginDate'] ?? '',
        endDate: v['endDate'] ?? '',
      })}
    />
  );
}

export function ClazzAttendanceExportBody({ pageId }: { pageId: string }): ReactElement {
  return <AttendanceLikeBodyInner pageId={pageId} title="課堂出席表現" />;
}

export function ClazzDetailExportBody({ pageId }: { pageId: string }): ReactElement {
  return <AttendanceLikeBodyInner pageId={pageId} title="開課明細表" />;
}

// ---------------------------------------------------------------------------
// 4. 訓練計畫表單匯出（report-common-plan-form-export）
// ---------------------------------------------------------------------------

const PLAN_FORM_EXPORT_INITIAL: Record<string, string> = {
  annualId: '114', // isDefault 選項 selected（:194-204；雛形取池第一筆【雛形值待實機校準】）
  organizationId: '',
  jobTypeId: '',
  departmentId: '',
  planTargetId: '',
  phaseTargetId: '',
  phaseDepartmentId: '',
  phaseType: '',
  formDepartmentId: '',
  formTemplateId: '',
  trainingStartDate: '',
  trainingEndDate: '',
  isShowScore: 'false',
  showEvaluator: '',
  showRated: '',
  formStatus: '',
};

export function PlanFormExportBody({ pageId }: { pageId: string }): ReactElement {
  const [values, setValues] = useState<Record<string, string>>(PLAN_FORM_EXPORT_INITIAL);
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  return (
    <ExportBodyShell
      pageId={pageId}
      title="訓練計畫表單匯出"
      actionLabel="匯出"
      actionUiId={`${pageId}-export-btn`}
      values={values}
      onSet={set}
      errors={{}}
      note={[
        '評分顯示方式：欄位為級距型或選擇型時，匯出文字描述或是分數值。',
        '評核者及受評者需要在表單的流程上設定才會有值。',
      ]}
      fields={(ctx) => (
        <>
          <ReportRow pageId={pageId} name="annualId" label="學年度：" star>
            <Select
              uiId={`${pageId}-field-annual-id`}
              name="annualId"
              value={ctx.v['annualId'] ?? ''}
              onChange={(next) => {
                ctx.set('annualId', next);
              }}
              options={selectOptionsOverride(pageId, 'annualId') ?? COURSE_CLAZZ_ANNUAL_OPTIONS}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="organizationId" label="醫院：" star>
            <Select
              uiId={`${pageId}-field-organization-id`}
              name="organizationId"
              value={ctx.v['organizationId'] ?? ''}
              onChange={(next) => {
                ctx.set('organizationId', next);
              }}
              options={selectOptionsOverride(pageId, 'organizationId') ?? ACCOUNT_ORGANIZATION_OPTIONS}
              {...(selectOptionsOverride(pageId, 'organizationId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="jobTypeId" label="訓練類別：" star>
            <Select
              uiId={`${pageId}-field-job-type-id`}
              name="jobTypeId"
              value={ctx.v['jobTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('jobTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'jobTypeId') ?? ACCOUNT_JOB_TYPE_OPTIONS}
              {...(selectOptionsOverride(pageId, 'jobTypeId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          {/* 科部（hidden searchPlanDepartmentId 群 :221-228）。 */}
          <div className="hidden">
            <ReportRow pageId={pageId} name="departmentId" label="科部：">
              <Select
                uiId={`${pageId}-field-department-id`}
                name="departmentId"
                value={ctx.v['departmentId'] ?? ''}
                onChange={(next) => {
                  ctx.set('departmentId', next);
                }}
                options={selectOptionsOverride(pageId, 'departmentId') ?? ACCOUNT_DEPARTMENT_OPTIONS}
                {...(selectOptionsOverride(pageId, 'departmentId') ? {} : { placeholder: '請選擇' })}
              />
            </ReportRow>
          </div>
          <ReportRow pageId={pageId} name="planTargetId" label="訓練計畫：" star>
            <Select
              uiId={`${pageId}-field-plan-target-id`}
              name="planTargetId"
              value={ctx.v['planTargetId'] ?? ''}
              onChange={(next) => {
                ctx.set('planTargetId', next);
              }}
              options={selectOptionsOverride(pageId, 'planTargetId') ?? COURSE_CLAZZ_PLAN_TARGET_OPTIONS}
              {...(selectOptionsOverride(pageId, 'planTargetId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="phaseTargetId" label="組別：">
            <Select
              uiId={`${pageId}-field-phase-target-id`}
              name="phaseTargetId"
              value={ctx.v['phaseTargetId'] ?? ''}
              onChange={(next) => {
                ctx.set('phaseTargetId', next);
              }}
              options={selectOptionsOverride(pageId, 'phaseTargetId') ?? COURSE_CLAZZ_PHASE_OPTIONS}
              {...(selectOptionsOverride(pageId, 'phaseTargetId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="phaseDepartmentId" label="訓練階段科部：" star error={ctx.errors['phaseDepartmentId']}>
            <Select
              uiId={`${pageId}-field-phase-department-id`}
              name="phaseDepartmentId"
              value={ctx.v['phaseDepartmentId'] ?? ''}
              onChange={(next) => {
                ctx.set('phaseDepartmentId', next);
              }}
              options={selectOptionsOverride(pageId, 'phaseDepartmentId') ?? ACCOUNT_DEPARTMENT_OPTIONS}
              {...(selectOptionsOverride(pageId, 'phaseDepartmentId') ? {} : { placeholder: '請選擇' })}
              invalid={ctx.errors['phaseDepartmentId'] !== undefined}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="phaseType" label="訓練階段類型：">
            <Select
              uiId={`${pageId}-field-phase-type`}
              name="phaseType"
              value={ctx.v['phaseType'] ?? ''}
              onChange={(next) => {
                ctx.set('phaseType', next);
              }}
              options={selectOptionsOverride(pageId, 'phaseType') ?? REPORT_PHASE_TYPE_PLAN_OPTIONS}
            />
          </ReportRow>
          <FormNameFields pageId={pageId} ctx={ctx} templateRequired />
          <DateRangeFields
            pageId={pageId}
            ctx={ctx}
            label="訓練期間："
            startName="trainingStartDate"
            endName="trainingEndDate"
            kind="month"
          />
          <ScoreStatusFields pageId={pageId} ctx={ctx} />
        </>
      )}
      chain={async (ctx) => {
        // :105 未選取訓練類別!
        if ((ctx.v['jobTypeId'] ?? '') === '') {
          return '未選取訓練類別!';
        }
        // :110 未選取訓練計畫!（空或 -1）
        const planTargetId = ctx.v['planTargetId'] ?? '';
        if (planTargetId === '' || planTargetId === '-1') {
          return '未選取訓練計畫!';
        }
        // :115 未選取表單名稱!
        if ((ctx.v['formTemplateId'] ?? '') === '') {
          return '未選取表單名稱!';
        }
        // :119-124 日期選取不正確!（月處理**之前**檢查原值）
        if (
          !isAfterOrSame(ctx.v['trainingStartDate'] ?? '', ctx.v['trainingEndDate'] ?? '')
        ) {
          return '日期選取不正確!';
        }
        return null;
      }}
      payload={(v) => {
        const range = monthRangePayload(v, 'trainingStartDate', 'trainingEndDate'); // :126-133
        return {
          annualId: v['annualId'] ?? '',
          organizationId: v['organizationId'] ?? '',
          jobTypeId: v['jobTypeId'] ?? '',
          departmentId: v['departmentId'] ?? '',
          planTargetId: v['planTargetId'] ?? '',
          phaseTargetId: v['phaseTargetId'] ?? '',
          phaseDepartmentId: (v['phaseDepartmentId'] ?? '') === '' ? '0' : (v['phaseDepartmentId'] ?? ''),
          phaseType: v['phaseType'] ?? '',
          formDepartmentId: v['formDepartmentId'] ?? '',
          formTemplateId: v['formTemplateId'] ?? '', // named 原值（C5-h）；legacy para 鍵=formTemplateIdList
          formTemplateIdList: v['formTemplateId'] ?? '',
          trainingStartDate: v['trainingStartDate'] ?? '', // named 原值（C5-h）；legacy para 送月展開值
          trainingStartDateMonth: range.start, // legacy para 值（月尾展開）【雛形值待實機校準】
          trainingEndDate: v['trainingEndDate'] ?? '',
          trainingEndDateMonth: range.end,
          isShowScore: v['isShowScore'] ?? 'false',
          isShowEvaluator: v['showEvaluator'] === '1' ? 'true' : 'false',
          isShowRated: v['showRated'] === '1' ? 'true' : 'false',
          formStatus: v['formStatus'] ?? '',
          enableStatus: 'true',
        };
      }}
    />
  );
}

// ---------------------------------------------------------------------------
// 5. 西醫PGY_學員各訓練階段總成績（report-pgywm-all-student-scores）
// ---------------------------------------------------------------------------

const ALL_STUDENT_SCORES_INITIAL: Record<string, string> = {
  annualId: '114',
  organizationId: '',
  jobTypeId: '2', // 西醫PGY selected（allStudentScores.jsp:52）
  planTargetId: '',
  phaseTargetGroupId: '',
  searchStudentCode: '',
  studentId: '',
};

export function AllStudentScoresBody({ pageId }: { pageId: string }): ReactElement {
  const [values, setValues] = useState<Record<string, string>>(ALL_STUDENT_SCORES_INITIAL);
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  return (
    <ExportBodyShell
      pageId={pageId}
      title="西醫PGY_學員各訓練階段總成績"
      actionLabel="匯出"
      actionUiId={`${pageId}-export-btn`}
      values={values}
      onSet={set}
      errors={{}}
      fields={(ctx) => (
        <>
          <ReportRow pageId={pageId} name="annualId" label="學年度：" star>
            <Select
              uiId={`${pageId}-field-annual-id`}
              name="annualId"
              value={ctx.v['annualId'] ?? ''}
              onChange={(next) => {
                ctx.set('annualId', next);
              }}
              options={selectOptionsOverride(pageId, 'annualId') ?? COURSE_CLAZZ_ANNUAL_OPTIONS}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="organizationId" label="醫院：" star>
            <Select
              uiId={`${pageId}-field-organization-id`}
              name="organizationId"
              value={ctx.v['organizationId'] ?? ''}
              onChange={(next) => {
                ctx.set('organizationId', next);
              }}
              options={selectOptionsOverride(pageId, 'organizationId') ?? ACCOUNT_ORGANIZATION_OPTIONS}
              {...(selectOptionsOverride(pageId, 'organizationId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="jobTypeId" label="訓練類別：" star>
            <Select
              uiId={`${pageId}-field-job-type-id`}
              name="jobTypeId"
              value={ctx.v['jobTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('jobTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'jobTypeId') ?? REPORT_JOB_TYPE_PGY}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="planTargetId" label="訓練計畫名稱：" star>
            <Select
              uiId={`${pageId}-field-plan-target-id`}
              name="planTargetId"
              value={ctx.v['planTargetId'] ?? ''}
              onChange={(next) => {
                ctx.set('planTargetId', next);
              }}
              options={selectOptionsOverride(pageId, 'planTargetId') ?? COURSE_CLAZZ_PLAN_TARGET_OPTIONS}
              {...(selectOptionsOverride(pageId, 'planTargetId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="phaseTargetGroupId" label="組別：">
            <Select
              uiId={`${pageId}-field-phase-target-group-id`}
              name="phaseTargetGroupId"
              value={ctx.v['phaseTargetGroupId'] ?? ''}
              onChange={(next) => {
                ctx.set('phaseTargetGroupId', next);
              }}
              options={selectOptionsOverride(pageId, 'phaseTargetGroupId') ?? COURSE_CLAZZ_PHASE_OPTIONS}
              {...(selectOptionsOverride(pageId, 'phaseTargetGroupId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          {/* 學員（searchStudentCode text＋studentId select 配對；JSP :68-77）。 */}
          <ReportRow pageId={pageId} name="searchStudentCode" label="學員：">
            <div className="flex gap-2">
              <TextInput
                uiId={`${pageId}-field-search-student-code`}
                name="searchStudentCode"
                value={ctx.v['searchStudentCode'] ?? ''}
                onChange={(next) => {
                  ctx.set('searchStudentCode', next);
                }}
                placeholder="(請輸入學員姓名或學員編號)"
              />
              <Select
                uiId={`${pageId}-field-student-id`}
                name="studentId"
                value={ctx.v['studentId'] ?? ''}
                onChange={(next) => {
                  ctx.set('studentId', next);
                }}
                // setAccountListByParamsForAllScores（js:101-127）關鍵字過濾打後端；
                // 雛形以平列池呈現不過濾【雛形值待實機校準】。
                options={selectOptionsOverride(pageId, 'studentId') ?? COURSE_CLAZZ_STUDENT_POOL}
                {...(selectOptionsOverride(pageId, 'studentId') ? {} : { placeholder: '請選擇' })}
              />
            </div>
          </ReportRow>
        </>
      )}
      chain={async (ctx) => {
        // js:67 請選擇訓練計畫!（legacy 判準 ==null；雛形以空值/-1 同攔＝intent 鏡像
        // 【雛形值待實機校準】——legacy 帶 -1 送出由 server NoData 收『查不到資料!』）
        const planTargetId = ctx.v['planTargetId'] ?? '';
        if (planTargetId === '' || planTargetId === '-1') {
          return '請選擇訓練計畫!';
        }
        return null;
      }}
      payload={(v) => ({
        annualId: v['annualId'] ?? '',
        organizationId: v['organizationId'] ?? '',
        jobTypeId: v['jobTypeId'] ?? '',
        planTargetId: v['planTargetId'] ?? '',
        phaseTargetGroupId: v['phaseTargetGroupId'] ?? '', // named 原值（C5-h）；legacy para 鍵=groupPhaseTargetId
        groupPhaseTargetId: v['phaseTargetGroupId'] ?? '',
        studentId: v['studentId'] ?? '',
        searchStudentCode: v['searchStudentCode'] ?? '',
      })}
    />
  );
}

// ---------------------------------------------------------------------------
// 6. 等第制表單明細（report-tsgh-gpa-form-report）
// ---------------------------------------------------------------------------

/** gpaFormReport.js init 的「今天」（js:41-42 moment now；雛形固定 DATE_EPOCH 2026/01/05）。 */
const REPORT_TODAY = '2026-01-05';

const GPA_FORM_INITIAL: Record<string, string> = {
  annualId: '114',
  organizationId: '',
  jobTypeId: '1', // 西醫UGY selected（gpaFormReport.jsp:52）
  planTargetId: '-1', // 請選擇 disabled selected（js init 重選 -1；JSP formTemplateId 同款 :85）
  phaseTargetDeptId: '',
  phaseType: '',
  formTemplateId: '-1', // 請選擇 disabled selected（:85）
  trainingStartDate: REPORT_TODAY,
  trainingEndDate: REPORT_TODAY,
};

export function GpaFormExportBody({ pageId }: { pageId: string }): ReactElement {
  const [values, setValues] = useState<Record<string, string>>(GPA_FORM_INITIAL);
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  return (
    <ExportBodyShell
      pageId={pageId}
      title="等第制表單明細"
      actionLabel="匯出"
      actionUiId={`${pageId}-export-btn`}
      values={values}
      onSet={set}
      errors={{}}
      note={[
        '當學員在該訓練期間若有填寫到不同版本的等第制表單，下載的檔案會用不同的[工作列表]來區分不同的表單版本，工作列表會以表單版本做顯示。',
      ]}
      fields={(ctx) => (
        <>
          <ReportRow pageId={pageId} name="annualId" label="學年度：" star>
            <Select
              uiId={`${pageId}-field-annual-id`}
              name="annualId"
              value={ctx.v['annualId'] ?? ''}
              onChange={(next) => {
                ctx.set('annualId', next);
              }}
              options={selectOptionsOverride(pageId, 'annualId') ?? COURSE_CLAZZ_ANNUAL_OPTIONS}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="organizationId" label="醫院：" star>
            <Select
              uiId={`${pageId}-field-organization-id`}
              name="organizationId"
              value={ctx.v['organizationId'] ?? ''}
              onChange={(next) => {
                ctx.set('organizationId', next);
              }}
              options={selectOptionsOverride(pageId, 'organizationId') ?? ACCOUNT_ORGANIZATION_OPTIONS}
              {...(selectOptionsOverride(pageId, 'organizationId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="jobTypeId" label="訓練類別：" star>
            <Select
              uiId={`${pageId}-field-job-type-id`}
              name="jobTypeId"
              value={ctx.v['jobTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('jobTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'jobTypeId') ?? REPORT_JOB_TYPE_UGY}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="planTargetId" label="訓練計畫名稱：" star>
            <Select
              uiId={`${pageId}-field-plan-target-id`}
              name="planTargetId"
              value={ctx.v['planTargetId'] ?? ''}
              onChange={(next) => {
                ctx.set('planTargetId', next);
              }}
              options={selectOptionsOverride(pageId, 'planTargetId') ?? [{ value: '-1', label: '請選擇' }, ...COURSE_CLAZZ_PLAN_TARGET_OPTIONS]}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="phaseTargetDeptId" label="訓練階段科部：" star>
            <Select
              uiId={`${pageId}-field-phase-target-dept-id`}
              name="phaseTargetDeptId"
              value={ctx.v['phaseTargetDeptId'] ?? ''}
              onChange={(next) => {
                ctx.set('phaseTargetDeptId', next);
              }}
              options={selectOptionsOverride(pageId, 'phaseTargetDeptId') ?? ACCOUNT_DEPARTMENT_OPTIONS}
              {...(selectOptionsOverride(pageId, 'phaseTargetDeptId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="phaseType" label="訓練階段類型：" star>
            <Select
              uiId={`${pageId}-field-phase-type`}
              name="phaseType"
              value={ctx.v['phaseType'] ?? ''}
              onChange={(next) => {
                ctx.set('phaseType', next);
              }}
              options={selectOptionsOverride(pageId, 'phaseType') ?? REPORT_PHASE_TYPE_OPTIONS}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="formTemplateId" label="表單名稱：" star>
            <Select
              uiId={`${pageId}-field-form-template-id`}
              name="formTemplateId"
              value={ctx.v['formTemplateId'] ?? ''}
              onChange={(next) => {
                ctx.set('formTemplateId', next);
              }}
              options={selectOptionsOverride(pageId, 'formTemplateId') ?? [{ value: '-1', label: '請選擇' }, ...COURSE_CLAZZ_FORM_TEMPLATE_OPTIONS]}
            />
          </ReportRow>
          <DateRangeFields
            pageId={pageId}
            ctx={ctx}
            label="訓練期間："
            startName="trainingStartDate"
            endName="trainingEndDate"
            star
            required
          />
        </>
      )}
      chain={async (ctx) => {
        // js:61 請選擇訓練計畫!（==null；JSP/js 預設 -1 請選擇——雛形攔 -1/空值＝intent 鏡像
        // 【雛形值待實機校準】；legacy 帶 -1 送出由 server NoData 收）
        const planTargetId = ctx.v['planTargetId'] ?? '';
        if (planTargetId === '' || planTargetId === '-1') {
          return '請選擇訓練計畫!';
        }
        // js:66 請選擇表單!（==null；預設 -1 同上）
        const formTemplateId = ctx.v['formTemplateId'] ?? '';
        if (formTemplateId === '' || formTemplateId === '-1') {
          return '請選擇表單!';
        }
        // js:79 請選開始時間!
        if ((ctx.v['trainingStartDate'] ?? '') === '') {
          return '請選開始時間!';
        }
        // js:84 請選擇結束時間!
        if ((ctx.v['trainingEndDate'] ?? '') === '') {
          return '請選擇結束時間!';
        }
        return null;
      }}
      payload={(v) => ({
        annualId: v['annualId'] ?? '',
        organizationId: v['organizationId'] ?? '',
        jobTypeId: v['jobTypeId'] ?? '',
        phaseTargetDeptId: v['phaseTargetDeptId'] ?? '', // named 原值（C5-h）；legacy para 鍵=phaseDepartmentId
        phaseDepartmentId: v['phaseTargetDeptId'] ?? '',
        planTargetId: v['planTargetId'] ?? '',
        phaseType: v['phaseType'] ?? '',
        formTemplateId: v['formTemplateId'] ?? '', // named 原值（C5-h）；legacy para 鍵=formTemplateIdList
        formTemplateIdList: v['formTemplateId'] ?? '',
        trainingStartDate: v['trainingStartDate'] ?? '',
        trainingEndDate: v['trainingEndDate'] ?? '',
      })}
    />
  );
}

// ---------------------------------------------------------------------------
// 7. 課程表單完成率監測（report-ugywm-course-form-finishrate）
// ---------------------------------------------------------------------------

const COURSE_FORM_FINISHRATE_INITIAL: Record<string, string> = {
  organizationId: '7', // 三軍總醫院 靜態（courseFormFinishrate.jsp:34-40）
  jobTypeId: '', // 請選擇 placeholder（:41-53）
  departmentId: '',
  kind: '',
  courseTypeId: '',
  StartDate: '2026-01', // initBeginDate js:67-73 預填當月【雛形值待實機校準】
  EndDate: '2026-01',
};

export function CourseFormFinishrateBody({ pageId }: { pageId: string }): ReactElement {
  const [values, setValues] = useState<Record<string, string>>(COURSE_FORM_FINISHRATE_INITIAL);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  return (
    <ExportBodyShell
      pageId={pageId}
      title="課程表單完成率監測"
      actionLabel="匯出"
      actionUiId={`${pageId}-export-btn`}
      values={values}
      onSet={set}
      errors={errors}
      fields={(ctx) => (
        <>
          <ReportRow pageId={pageId} name="organizationId" label="醫院：" star>
            <Select
              uiId={`${pageId}-field-organization-id`}
              name="organizationId"
              value={ctx.v['organizationId'] ?? ''}
              onChange={(next) => {
                ctx.set('organizationId', next);
              }}
              options={selectOptionsOverride(pageId, 'organizationId') ?? [{ value: '7', label: '三軍總醫院' }]}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="jobTypeId" label="訓練類別：" star>
            <Select
              uiId={`${pageId}-field-job-type-id`}
              name="jobTypeId"
              value={ctx.v['jobTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('jobTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'jobTypeId') ?? REPORT_JOB_TYPE_FINISHRATE_OPTIONS}
              {...(selectOptionsOverride(pageId, 'jobTypeId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="departmentId" label="部門：" star error={ctx.errors['departmentId']}>
            <Select
              uiId={`${pageId}-field-department-id`}
              name="departmentId"
              value={ctx.v['departmentId'] ?? ''}
              onChange={(next) => {
                ctx.set('departmentId', next);
              }}
              options={selectOptionsOverride(pageId, 'departmentId') ?? ACCOUNT_DEPARTMENT_OPTIONS}
              {...(selectOptionsOverride(pageId, 'departmentId') ? {} : { placeholder: '請選擇' })}
              invalid={ctx.errors['departmentId'] !== undefined}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="kind" label="類型：" star>
            <Select
              uiId={`${pageId}-field-kind`}
              name="kind"
              value={ctx.v['kind'] ?? ''}
              onChange={(next) => {
                ctx.set('kind', next);
              }}
              options={selectOptionsOverride(pageId, 'kind') ?? REPORT_KIND_FINISHRATE_OPTIONS}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="courseTypeId" label="課程類別：" star>
            <Select
              uiId={`${pageId}-field-course-type-id`}
              name="courseTypeId"
              value={ctx.v['courseTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('courseTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'courseTypeId') ?? COURSE_CLAZZ_COURSE_TYPE_OPTIONS}
              {...(selectOptionsOverride(pageId, 'courseTypeId') ? {} : { placeholder: '請選擇' })}
            />
          </ReportRow>
          <DateRangeFields
            pageId={pageId}
            ctx={ctx}
            label="期間："
            startName="StartDate"
            endName="EndDate"
            star
            required
            kind="month"
          />
        </>
      )}
      chain={async (ctx) => {
        // js:116 valid()（required：departmentId/StartDate/EndDate）
        const requiredErrors = requiredErrorsOf(ctx, ['departmentId', 'StartDate', 'EndDate']);
        if (requiredErrors !== null) {
          setErrors(requiredErrors);
          return ''; // legacy valid() false → return false 不匯出（js:116）
        }
        setErrors({});
        // js:119-129 月處理後 :130-133 日期選取不正確!（isAfterOrSame 比較月值——
        // legacy 先 new Date(beginDate)（'2026-01'→01-01）再比；鏡像同語意）
        if (!isAfterOrSame(ctx.v['StartDate'] ?? '', ctx.v['EndDate'] ?? '')) {
          return '日期選取不正確!';
        }
        return null;
      }}
      payload={(v) => {
        // js:119-129：起月首日/訖月末日（name=StartDate/EndDate → classStartDate/classEndDate）。
        return {
          organizationId: v['organizationId'] ?? '',
          jobTypeId: v['jobTypeId'] ?? '',
          departmentId: v['departmentId'] ?? '',
          kind: v['kind'] ?? '',
          courseTypeId: v['courseTypeId'] ?? '',
          StartDate: v['StartDate'] ?? '', // named 原值（C5-h）；legacy para 送月展開後的 classStart/EndDate
          EndDate: v['EndDate'] ?? '',
          classStartDate: monthRangePayload(v, 'StartDate', 'EndDate').start,
          classEndDate: monthRangePayload(v, 'StartDate', 'EndDate').end,
        };
      }}
    />
  );
}

// ---------------------------------------------------------------------------
// 8. 西醫UGY_學員對科部整體滿意度問卷統計（report-ugywm-student-dept-satisfy）
// ---------------------------------------------------------------------------

const STUDENT_DEPT_SATISFY_INITIAL: Record<string, string> = {
  departmentId: '0', // hidden value=0（studentDeptSatisfy.jsp:122）
  annualId: '0', // 0=全部（:123-135，label 無星）
  organizationId: '7', // 三軍總醫院 靜態（:136-142）
  jobTypeId: '1', // 西醫UGY 靜態（:143-149）
  planTargetId: '0', // annual '0' → planTarget prepend 全部(0)（js init :14-27 鏡像）
  trainingStartDate: '',
  trainingEndDate: '',
};

export function StudentDeptSatisfyBody({ pageId }: { pageId: string }): ReactElement {
  const [values, setValues] = useState<Record<string, string>>(STUDENT_DEPT_SATISFY_INITIAL);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  return (
    <ExportBodyShell
      pageId={pageId}
      title="西醫UGY_學員對科部整體滿意度問卷統計"
      actionLabel="匯出"
      actionUiId={`${pageId}-export-btn`}
      values={values}
      onSet={set}
      errors={errors}
      fields={(ctx) => (
        <>
          {/* hidden departmentId（:122）。 */}
          <input type="hidden" name="departmentId" value={ctx.v['departmentId'] ?? '0'} readOnly />
          <ReportRow pageId={pageId} name="annualId" label="學年度：" error={ctx.errors['annualId']}>
            <Select
              uiId={`${pageId}-field-annual-id`}
              name="annualId"
              value={ctx.v['annualId'] ?? ''}
              onChange={(next) => {
                ctx.set('annualId', next);
                // js init :14-27 鏡像：annual '0' → planTarget prepend 全部(0)；其他 →
                // setPlanTargetElement（-1 請選擇＋清單）。雛形在畫面層級聯。
                ctx.set('planTargetId', next === '0' ? '0' : '-1');
              }}
              options={selectOptionsOverride(pageId, 'annualId') ?? [{ value: '0', label: '全部' }, ...COURSE_CLAZZ_ANNUAL_OPTIONS]}
              invalid={ctx.errors['annualId'] !== undefined}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="organizationId" label="醫院：" star>
            <Select
              uiId={`${pageId}-field-organization-id`}
              name="organizationId"
              value={ctx.v['organizationId'] ?? ''}
              onChange={(next) => {
                ctx.set('organizationId', next);
              }}
              options={selectOptionsOverride(pageId, 'organizationId') ?? [{ value: '7', label: '三軍總醫院' }]}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="jobTypeId" label="訓練類別：" star>
            <Select
              uiId={`${pageId}-field-job-type-id`}
              name="jobTypeId"
              value={ctx.v['jobTypeId'] ?? ''}
              onChange={(next) => {
                ctx.set('jobTypeId', next);
              }}
              options={selectOptionsOverride(pageId, 'jobTypeId') ?? REPORT_JOB_TYPE_UGY}
            />
          </ReportRow>
          <ReportRow pageId={pageId} name="planTargetId" label="訓練計畫：" error={ctx.errors['planTargetId']}>
            <Select
              uiId={`${pageId}-field-plan-target-id`}
              name="planTargetId"
              value={ctx.v['planTargetId'] ?? ''}
              onChange={(next) => {
                ctx.set('planTargetId', next);
              }}
              // js :14-27 鏡像：annual '0' → 只有 全部(0)；其他 → -1 請選擇＋計畫清單。
              options={selectOptionsOverride(pageId, 'planTargetId') ?? ((ctx.v['annualId'] ?? '0') === '0'
                  ? [{ value: '0', label: '全部' }]
                  : [{ value: '-1', label: '請選擇' }, ...COURSE_CLAZZ_PLAN_TARGET_OPTIONS])}
              invalid={ctx.errors['planTargetId'] !== undefined}
            />
          </ReportRow>
          <DateRangeFields
            pageId={pageId}
            ctx={ctx}
            label="訓練期間(起迄)："
            startName="trainingStartDate"
            endName="trainingEndDate"
            star
            required
          />
        </>
      )}
      chain={async (ctx) => {
        // :47 未選擇訓練計畫（== '-1'）
        if ((ctx.v['planTargetId'] ?? '') === '-1') {
          return '未選擇訓練計畫';
        }
        // :50 valid()（required：annualId/planTargetId/trainingStartDate/trainingEndDate）
        const requiredErrors = requiredErrorsOf(ctx, [
          'annualId',
          'planTargetId',
          'trainingStartDate',
          'trainingEndDate',
        ]);
        if (requiredErrors !== null) {
          setErrors(requiredErrors);
          return ''; // legacy valid() false → return false 不匯出（:50）
        }
        setErrors({});
        // :53-57 日期選取不正確!
        if (
          !isAfterOrSame(ctx.v['trainingStartDate'] ?? '', ctx.v['trainingEndDate'] ?? '')
        ) {
          return '日期選取不正確!';
        }
        return null;
      }}
      payload={(v) => {
        const range = monthRangePayload(v, 'trainingStartDate', 'trainingEndDate'); // :66-73
        return {
          departmentId: v['departmentId'] ?? '0',
          annualId: v['annualId'] ?? '',
          organizationId: v['organizationId'] ?? '',
          jobTypeId: v['jobTypeId'] ?? '',
          planTargetId: v['planTargetId'] ?? '',
          trainingStartDate: v['trainingStartDate'] ?? '', // named 原值（C5-h）；legacy para 送月展開值
          trainingStartDateMonth: range.start, // legacy para 值（月尾展開）【雛形值待實機校準】
          trainingEndDate: v['trainingEndDate'] ?? '',
          trainingEndDateMonth: range.end,
        };
      }}
    />
  );
}

// ---------------------------------------------------------------------------
// 9/10. 核心技能統計(依技能)／(依學員)（雙胞胎：coreSkillFormReport／coreSkillSutdentReport）
// ---------------------------------------------------------------------------

const CORE_SKILL_INITIAL: Record<string, string> = {
  annualId: '114',
  organizationId: '',
  jobTypeId: '',
  departmentId: '',
  planTargetId: '',
  annualId2: '114',
  organizationId2: '',
  jobTypeId2: '',
  departmentId2: '',
  planTargetId2: '',
};

export function CoreSkillFormReportBody({ pageId }: { pageId: string }): ReactElement {
  return <CoreSkillLikeBody pageId={pageId} title="核心技能統計(依技能)" />;
}

export function CoreSkillSutdentReportBody({ pageId }: { pageId: string }): ReactElement {
  return <CoreSkillLikeBody pageId={pageId} title="核心技能統計(依學員)" />;
}

/** 雙胞胎共用（差異：標題＋fileDownload URL——payload 同構）。 */
function CoreSkillLikeBody({ pageId, title }: { pageId: string; title: string }): ReactElement {
  const [values, setValues] = useState<Record<string, string>>(CORE_SKILL_INITIAL);
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  const halfFields = (suffix: string, labeled: boolean) => (
    <>
      {/* 批次 52 修訂（b52-calibrate3，F-2）：OPTION_SET_OVERRIDES 命中＝凍結選項集取代寫死常數
          （規格 §7.1；suffix ''/2 兩組共 10 鍵；override 命中含空陣列即移除 placeholder 空選項）。 */}
      <ReportRow
        pageId={pageId}
        name={`annualId${suffix}`}
        label="學年度："
        star={labeled}
      >
        <Select
          uiId={`${pageId}-field-annual-id${suffix}`}
          name={`annualId${suffix}`}
          value={values[`annualId${suffix}`] ?? ''}
          onChange={(next) => {
            set(`annualId${suffix}`, next);
          }}
          options={selectOptionsOverride(pageId, `annualId${suffix}`) ?? COURSE_CLAZZ_ANNUAL_OPTIONS}
        />
      </ReportRow>
      <ReportRow pageId={pageId} name={`organizationId${suffix}`} label="醫院：" star={labeled}>
        <Select
          uiId={`${pageId}-field-organization-id${suffix}`}
          name={`organizationId${suffix}`}
          value={values[`organizationId${suffix}`] ?? ''}
          onChange={(next) => {
            set(`organizationId${suffix}`, next);
          }}
          options={selectOptionsOverride(pageId, `organizationId${suffix}`) ?? ACCOUNT_ORGANIZATION_OPTIONS}
          {...(selectOptionsOverride(pageId, `organizationId${suffix}`) ? {} : { placeholder: '請選擇' })}
        />
      </ReportRow>
      <ReportRow pageId={pageId} name={`jobTypeId${suffix}`} label="訓練類別：" star={labeled}>
        <Select
          uiId={`${pageId}-field-job-type-id${suffix}`}
          name={`jobTypeId${suffix}`}
          value={values[`jobTypeId${suffix}`] ?? ''}
          onChange={(next) => {
            set(`jobTypeId${suffix}`, next);
          }}
          options={selectOptionsOverride(pageId, `jobTypeId${suffix}`) ?? ACCOUNT_JOB_TYPE_OPTIONS}
          {...(selectOptionsOverride(pageId, `jobTypeId${suffix}`) ? {} : { placeholder: '請選擇' })}
        />
      </ReportRow>
      {/* 科部（hidden 群）。 */}
      <div className="hidden">
        <ReportRow pageId={pageId} name={`departmentId${suffix}`} label="科部：" star={labeled}>
          <Select
            uiId={`${pageId}-field-department-id${suffix}`}
            name={`departmentId${suffix}`}
            value={values[`departmentId${suffix}`] ?? ''}
            onChange={(next) => {
              set(`departmentId${suffix}`, next);
            }}
            options={selectOptionsOverride(pageId, `departmentId${suffix}`) ?? ACCOUNT_DEPARTMENT_OPTIONS}
            {...(selectOptionsOverride(pageId, `departmentId${suffix}`) ? {} : { placeholder: '請選擇' })}
          />
        </ReportRow>
      </div>
      <ReportRow
        pageId={pageId}
        name={`planTargetId${suffix}`}
        label="訓練計畫："
        star
      >
        <Select
          uiId={`${pageId}-field-plan-target-id${suffix}`}
          name={`planTargetId${suffix}`}
          value={values[`planTargetId${suffix}`] ?? ''}
          onChange={(next) => {
            set(`planTargetId${suffix}`, next);
          }}
          options={selectOptionsOverride(pageId, `planTargetId${suffix}`) ?? COURSE_CLAZZ_PLAN_TARGET_OPTIONS}
          {...(selectOptionsOverride(pageId, `planTargetId${suffix}`) ? {} : { placeholder: '請選擇' })}
        />
      </ReportRow>
    </>
  );
  return (
    <ExportBodyShell
      pageId={pageId}
      title={title}
      actionLabel="匯出"
      actionUiId={`${pageId}-export-btn`}
      values={values}
      onSet={set}
      errors={{}}
      fields={() => (
        <>
          {halfFields('', true)}
          {halfFields('2', false)}
        </>
      )}
      chain={async () => {
        // :116 valid() 恆過（本頁契欄無 required 欄位；legacy 先 valid 再檢 planTarget）。
        // :119-121 未選擇訓練計畫（== '-1'；雛形同攔空值【雛形值待實機校準】）
        const planTargetId = values['planTargetId'] ?? '';
        if (planTargetId === '' || planTargetId === '-1') {
          return '未選擇訓練計畫';
        }
        return null;
      }}
      payload={(v) => ({
        annualId: v['annualId'] ?? '',
        organizationId: v['organizationId'] ?? '',
        jobTypeId: v['jobTypeId'] ?? '',
        departmentId: v['departmentId'] ?? '',
        planTargetId: v['planTargetId'] ?? '',
        annualId2: v['annualId2'] ?? '',
        organizationId2: v['organizationId2'] ?? '',
        jobTypeId2: v['jobTypeId2'] ?? '',
        departmentId2: v['departmentId2'] ?? '',
        planTargetId2: v['planTargetId2'] ?? '',
      })}
    />
  );
}

